module.exports = __webpack_public_path__ + "static/media/video-upload.180ae49a.svg";